import { sdk } from 'src/utilities/sdk';
import { CreateCorpResponse, CorpUIPayload, CorpPayload } from 'src/types/Corp';
import { decamelizeRequestBody } from 'src/utilities/http-data-casing';

export const CORPORATE_CREATE_ENDPOINT = '/corps';

export function createCorporate(
  corpData: CorpUIPayload
): Promise<CreateCorpResponse> {
  const decamelizedCorpData = decamelizeRequestBody(
    corpData
  ) as unknown as CorpPayload;
  return sdk.http.post(CORPORATE_CREATE_ENDPOINT, decamelizedCorpData);
}
